import React from "react";
import PropTypes from "prop-types";

import SC_Icon from "../../../Img/SC/SC_Icon.png";
import DM_Icon from "../../../Img/DM/DM_Icon.png";

import * as Theme from "../../../App/Theme";

import TButton from "../../../Library/Buttons/TButton";
import TBox from "../../../Library/OtherComponents/TBox";

import * as GBConst from "../NonComponents/GBConst";
import { getModName, shouldComponentUpdateGB } from "../NonComponents/GBUtil";

const modDivMargin = 15;

const modDivWidth = 340;
const modDivHeight = 380;

const modDivStyle = {
    borderColor: Theme.HL_PrimaryColor,
    borderRadius: 20,
    borderStyle: "solid",
    borderWidth: 2,
    height: modDivHeight,
    width: modDivWidth,
};

const modDivUpperBoxStyle = {
    height: 280,
    width: modDivWidth - modDivMargin * 2,
};

const modDivEnterBtnBoxStyle = {
    height: modDivHeight - modDivUpperBoxStyle.height - 40,
    width: modDivWidth - modDivMargin * 2,
};

/* Unfortunately, we can't just grab the height of the button from the button and do 1/2 height of
   the button's container - 1/2 height of the button. */
const modDivEnterBtnTop = 10;

function DM_ModNameLab(DMVersion) {
    function getLineBreak(DMVersion) {
        let result;
        if ([GBConst.GB_3MC_2025, GBConst.GB_Original_2025].includes(DMVersion)) {
            result = <br></br>;
        }
        return result;
    }
    function getSubtitle(DMVersion) {
        let result = "";
        // if ([GBConst.GB_3MC_2024, GBConst.GB_Original_2024].includes(DMVersion)){
        //     result = "(coming soon!)"
        // }
        return result;
    }
    return (
        <h3
            key={"DM_ModNameLab" + DMVersion}
            style={{
                color: Theme.HL_PrimaryColor,
            }}
        >
            {getModName(GBConst.GB_DM, DMVersion)}
            {getLineBreak(DMVersion)}
            {getSubtitle(DMVersion)}
        </h3>
    );
}

function DM_ModDescriptionLab(DMVersion) {
    let result = "";

    if ([GBConst.GB_3MC_2025].includes(DMVersion)) {
        result = (
            <p
                key={"DM_ModDescriptionLab"}
                style={{
                    fontWeight: "normal",
                    marginTop: 0,
                }}
            >
                <b>
                    This version integrates data from the "threeMC" VMMC coverage model. Includes VMMC program data
                    through December 2024.
                </b>
            </p>
        );
    }

    if ([GBConst.GB_Original_2025].includes(DMVersion)) {
        result = (
            <p
                key={"DM_ModDescriptionLab"}
                style={{
                    fontWeight: "normal",
                    marginTop: 0,
                }}
            >
                <b>This is the original version of DMPPT 2. Includes VMMC program data through December 2024.</b>
            </p>
        );
    }

    if ([GBConst.GB_3MC_2024].includes(DMVersion)) {
        result = (
            <p
                key={"DM_ModDescriptionLab"}
                style={{
                    fontWeight: "normal",
                    marginTop: 0,
                }}
            >
                <b>
                    This version integrates data from the "threeMC" VMMC coverage model. Includes VMMC program data
                    through December 2023.
                </b>
            </p>
        );
    }

    if ([GBConst.GB_Original_2024].includes(DMVersion)) {
        result = (
            <p
                key={"DM_ModDescriptionLab"}
                style={{
                    fontWeight: "normal",
                    marginTop: 0,
                }}
            >
                <b>This is the original version of DMPPT 2. Includes VMMC program data through December 2023.</b>
            </p>
        );
    }

    if ([GBConst.GB_3MC_2023].includes(DMVersion)) {
        result = (
            <p
                key={"DM_ModDescriptionLab"}
                style={{
                    fontWeight: "normal",
                    marginTop: 0,
                }}
            >
                <b>
                    This version integrates data from the "threeMC" VMMC coverage model. Includes VMMC program data
                    through December 2022.
                </b>
            </p>
        );
    }

    if ([GBConst.GB_Original_2023].includes(DMVersion)) {
        result = (
            <p
                key={"DM_ModDescriptionLab"}
                style={{
                    fontWeight: "normal",
                    marginTop: 0,
                }}
            >
                <b>This is the original version of DMPPT 2. Includes VMMC program data through December 2022.</b>
            </p>
        );
    }

    return result;
}

function DM_UpperBoxContent(DMVersion) {
    const DM_IconBox = (
        <TBox
            content={[
                <img
                    alt="" // to avoid hint
                    key={"DM_IconBox"}
                    src={DM_Icon}
                />,
            ]}
            justifyContent={"flex-end"}
            key={"DM_IconBox"}
            style={{
                width: modDivWidth - 20,
            }}
        />
    );

    let DM_UpperBoxContent = [];
    DM_UpperBoxContent.push(DM_IconBox);
    DM_UpperBoxContent.push(DM_ModNameLab(DMVersion));
    DM_UpperBoxContent.push(DM_ModDescriptionLab(DMVersion));
    return DM_UpperBoxContent;
}

function DM_UpperBox(DMVersion) {
    const DM_UpperBox = (
        <TBox
            content={DM_UpperBoxContent(DMVersion)}
            justifyContent={"flex-start"}
            key={"DM_UpperBox" + DMVersion}
            flexDirection={"column"}
            style={{
                ...modDivUpperBoxStyle,
            }}
        />
    );

    return DM_UpperBox;
}

function onEnter(props, DMVersion) {
    switch (DMVersion) {
        case GBConst.GB_3MC_2024:
            return window.open("http://www.vmmcipt.org/2024_3MC/", "_self");
        case GBConst.GB_Original_2024:
            return window.open("http://www.vmmcipt.org/2024/", "_self");
        case GBConst.GB_3MC_2025:
            return window.open("http://www.vmmcipt.org/2025_3MC/", "_self");
        case GBConst.GB_Original_2025:
            return props.onModuleChange(GBConst.GB_DM);
        default:
            return null;
    }
}

function DM_EnterBtn(props, DMVersion) {
    let DM_EnterBtn = (
        <TButton
            caption={"Enter"}
            onClick={() => onEnter(props, DMVersion)}
            containerStyle={{
                ...modDivEnterBtnBoxStyle,
            }}
            key={"DM_EnterBtn" + DMVersion}
            style={{ top: modDivEnterBtnTop }}
        />
    );

    // if ([GBConst.GB_3MC_2024, GBConst.GB_Original_2024].includes(DMVersion)){
    //     DM_EnterBtn = (
    //         <TButton
    //             disabled
    //             caption={"Enter"}
    //             onClick={() => onEnter(props, DMVersion)}
    //             containerStyle={{
    //                 ...modDivEnterBtnBoxStyle,
    //             }}
    //             key={"DM_EnterBtn" + DMVersion}
    //             style={{top: modDivEnterBtnTop}}
    //         />
    //     );
    // }

    return DM_EnterBtn;
}

function DM_EnterBtnBoxContent(props, DMVersion) {
    let DM_EnterBtnBoxContent = [];
    DM_EnterBtnBoxContent.push(DM_EnterBtn(props, DMVersion));
    return DM_EnterBtnBoxContent;
}

function DM_EnterBtnBox(props, DMVersion) {
    const DM_EnterBtnBox = (
        <TBox
            content={DM_EnterBtnBoxContent(props, DMVersion)}
            key={"DM_EnterBtnBox" + DMVersion}
        />
    );

    return DM_EnterBtnBox;
}

function DM_BoxContent(props, DMVersion) {
    let DM_BoxContent = [];
    DM_BoxContent.push(DM_UpperBox(DMVersion));
    DM_BoxContent.push(DM_EnterBtnBox(props, DMVersion));
    return DM_BoxContent;
}

function DM_Box(props, DMVersion) {
    const DM_Box = (
        <TBox
            content={DM_BoxContent(props, DMVersion)}
            flexDirection={"column"}
            key={"DM_Box" + DMVersion}
            style={{
                ...modDivStyle,
                margin: 10, // needed to prevent boxes from clashing when window is resized and to keep them aligned relative to each other
            }}
        />
    );

    return DM_Box;
}

class GBStartScreenForm extends React.Component {
    static propTypes = {
        onModuleChange: PropTypes.func,
    };

    static defaultProps = {
        onModuleChange: () => console.log("onModuleChange"),
    };

    /* Avoid re-rendering if we don't have to (if no props or state affect this form). */
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdateGB(this.props, nextProps, this.state, nextState);
    }

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        try {
            const props = this.props;
            const onModuleChange = props.onModuleChange;

            const welcomeText = (
                <h1
                    key={"welcomeText"}
                    style={{
                        color: Theme.HL_PrimaryColor,
                        fontFamily: Theme.fontFamily,
                        textAlign: "center",
                    }}
                >
                    Welcome to {getModName(GBConst.GB_GB)} !
                </h1>
            );

            const DMInstructions = (
                <p
                    key={"DMInstructions"}
                    style={{
                        fontFamily: Theme.fontFamily,
                        textAlign: "center",
                    }}
                >
                    <b STYLE="color : #0D47A1">DMPPT 2</b> is a monitoring and planning tool that generates coverage
                    estimates and target impact projections for VMMC programs. Please select a version of DMPPT 2 below
                    to begin.
                </p>
            );

            const SCInstructions = (
                <p
                    key={"SCInstructions"}
                    style={{
                        fontFamily: Theme.fontFamily,
                        textAlign: "center",
                    }}
                >
                    The <b STYLE="color : #0D47A1">VMMC Site Capacity and Productivity Assessment Tool</b> is a tool for
                    assessing the productivity and efficiency of VMMC sites.
                </p>
            );

            const DataPrepAndUploadLink = (
                <p
                    key={"DataPrepAndUploadLink"}
                    style={{
                        fontFamily: Theme.fontFamily,
                        textAlign: "center",
                    }}
                >
                    *If your country is not shown here, the country team must download the appropriate input form from
                    the{" "}
                    <a
                        href="https://adr.unaids.org/en/dataset-2/vmmc-data-input-forms-2023"
                        target="_blank"
                    >
                        ADR
                    </a>
                    , fill it out, upload it to the{" "}
                    <a
                        href="https://adr.unaids.org/en/dataset-2/vmmc-data-input-forms-2023"
                        target="_blank"
                    >
                        ADR
                    </a>
                    , and notify Avenir Health. For more details, see{" "}
                    <a
                        href="resources/DM/download/DMPPT2%20Data%20Preparation%20&%20Upload.pdf"
                        target="_blank"
                    >
                        Data Preparation & Upload.
                    </a>
                </p>
            );

            const SC_IconBox = (
                <TBox
                    content={[
                        <img
                            alt="" // to avoid hint
                            key={"SC_IconBoxImg"}
                            src={SC_Icon}
                        />,
                    ]}
                    key={"SC_IconBox"}
                    justifyContent={"flex-end"}
                    style={{
                        width: modDivWidth - 20,
                    }}
                />
            );

            const SC_ModNameLab = (
                <h3
                    key={"SC_ModNameLab"}
                    style={{
                        color: Theme.HL_PrimaryColor,
                    }}
                >
                    {getModName(GBConst.GB_SC)}
                </h3>
            );

            const SC_ModDescriptionLab = (
                <h3
                    key={"SC_ModDescriptionLab"}
                    style={{
                        fontWeight: "normal",
                        marginTop: 0,
                    }}
                >
                    A tool for assessing the productivity and efficiency of VMMC sites
                </h3>
            );

            let SC_UpperBoxContent = [];
            SC_UpperBoxContent.push(SC_IconBox);
            SC_UpperBoxContent.push(SC_ModNameLab);
            SC_UpperBoxContent.push(SC_ModDescriptionLab);

            const SC_UpperBox = (
                <TBox
                    content={SC_UpperBoxContent}
                    key={"SC_UpperBox"}
                    flexDirection={"column"}
                    justifyContent={"flex-start"}
                    style={{
                        ...modDivUpperBoxStyle,
                    }}
                />
            );

            const SC_EnterBtn = (
                <TButton
                    caption={"Enter"}
                    onClick={() => onModuleChange(GBConst.GB_SC)}
                    containerStyle={{
                        ...modDivEnterBtnBoxStyle,
                    }}
                    key={"SC_EnterBtn"}
                    style={{
                        top: modDivEnterBtnTop,
                    }}
                />
            );

            let SC_EnterBtnBoxContent = [];
            SC_EnterBtnBoxContent.push(SC_EnterBtn);

            const SC_EnterBtnBox = (
                <TBox
                    content={SC_EnterBtnBoxContent}
                    key={"SC_EnterBtnBox"}
                />
            );

            let SC_BoxContent = [];
            SC_BoxContent.push(SC_UpperBox);
            SC_BoxContent.push(SC_EnterBtnBox);

            const SC_Box = (
                <TBox
                    content={SC_BoxContent}
                    flexDirection={"column"}
                    key={"SC_Box"}
                    style={{
                        ...modDivStyle,
                        margin: 10, // needed to prevent boxes from clashing when window is resized and to keep them aligned relative to each other
                    }}
                />
            );

            let modulesBoxContentDM = [];
            // modulesBoxContentDM.push(DM_Box(props, GBConst.GB_3MC_2025));
            // modulesBoxContentDM.push(DM_Box(props, GBConst.GB_Original_2025));
            modulesBoxContentDM.push(DM_Box(props, GBConst.GB_3MC_2024));
            modulesBoxContentDM.push(DM_Box(props, GBConst.GB_Original_2024));

            let modulesBoxContentSC = [SC_Box];

            const linebreak = <br></br>;

            const divider = <div STYLE="background-color:#4774C5; height:3.5px; width:100%;"></div>;

            const modulesBoxDM = (
                <TBox
                    content={modulesBoxContentDM}
                    key={"modulesBox"}
                />
            );

            const modulesBoxSC = (
                <TBox
                    content={modulesBoxContentSC}
                    key={"modulesBox"}
                />
            );

            return (
                <div key={"GBStartScreenFormDiv"}>
                    {welcomeText}
                    {linebreak}
                    {divider}
                    {linebreak}
                    {DMInstructions}
                    {modulesBoxDM}
                    {linebreak}
                    {DataPrepAndUploadLink}
                    {linebreak}
                    {divider}
                    {linebreak}
                    {SCInstructions}
                    {linebreak}
                    {modulesBoxSC}
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"GBStartScreenFormDiv"}
                    key={"GBStartScreenFormDiv"}
                >
                    <h3 key={"GBStartScreenFormDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default GBStartScreenForm;
